import { Booking } from '@collinsonx/utils';

export const filterMissingProperties = (booking: Partial<Booking>) =>
  Object.fromEntries(
    Object.entries(booking).filter(([, value]) => value !== undefined)
  );
